import React, { useState } from 'react'
import { Button, Form, InputText } from '../../../ui'
import { MAX_LENGTH, VALIDATE_EMAIL_REGEXP } from '../../../constants/constants'
import { CREATE_ACCOUNT } from '../../../constants/routes'
import { checkPammRegistration } from '../../api'
import { useStore } from '../../../StateProvider'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styles from './style.css'

const InvestorAccountForm = ({ fundId, fundName }) => {
  const { t, i18n: { language } } = useTranslation()
  const createAccountLink = `${CREATE_ACCOUNT}?fund_id=${fundId}`

  const [email, setEmail] = useState('')
  const [isEmailValid, setIsEmailValid] = useState(null)
  const [emailError, setEmailError] = useState('')
  const [isEmailNotFoundError, setIsEmailNotFoundError] = useState(false)
  const [isEmailCheckLoading, setIsEmailCheckLoading] = useState(false)
  const [isOtherEntityError, setIsOtherEntityError] = useState(false)
  const [submitError, setSubmitError] = useState('')
  const [timer, setTimer] = useState(0)

  const [{ whitelabel: { loginURL } }, dispatch] = useStore()

  const getCreateAccountLink = () => {
    return `${loginURL}?fundId=${fundId}&lang=${language}`
  }

  const onSubmit = () => {
    dispatch({ type: 'setUser', user: { email } })
    setIsEmailCheckLoading(true)
    setSubmitError('')
    const resolve = ({ accountFound, sameEntity }) => {
      if (accountFound && sameEntity) {
        setIsEmailNotFoundError(false)
        window.location.href = getCreateAccountLink()
      } else if (accountFound && !sameEntity) {
        setIsOtherEntityError(true)
        setIsEmailCheckLoading(false)
      } else {
        setIsEmailNotFoundError(true)
        setIsEmailCheckLoading(false)
        setIsOtherEntityError(false)
      }
    }
    const reject = ({ message }) => {
      setIsEmailCheckLoading(false)
      setSubmitError(message)
    }
    checkPammRegistration(email, fundId).then(resolve, reject)
  }

  const onChange = ({ target: { value } }) => {
    setIsEmailNotFoundError(false)
    setIsOtherEntityError(false)
    setEmail(value)
    setIsEmailValid(false)
    setEmailError('')
    clearTimeout(timer)
    const curTimer = setTimeout(() => {
      onBlur({ target: { value } })
    }, 3000)
    setTimer(curTimer)
  }

  const onBlur = ({ target: { value } }) => {
    const trimmedValue = value.trim()
    const isValid = VALIDATE_EMAIL_REGEXP.test(trimmedValue)
    if (isValid) {
      setIsEmailValid(true)
      setEmailError('')
    } else {
      setIsEmailValid(false)
      setEmailError('emailField.invalid')
    }
  }

  const onFormSubmit = (e) => {
    e.preventDefault()
    onBlur({ target: { value: email } })
    if (VALIDATE_EMAIL_REGEXP.test(email.trim())) {
      onSubmit()
    }
  }

  return (
    <>
      <div className={styles.additionalText}>
        {t('createInvestorAccount.welcome', { fundName })}
        <div>{t('createInvestorAccount.accountPresence')}</div>
      </div>
      <Form onSubmit={onFormSubmit}>
        <InputText
          name='email'
          label={t('createInvestorAccount.email')}
          value={email}
          maxLength={MAX_LENGTH}
          error={t(emailError)}
          onChange={onChange}
          onBlur={onBlur}
          valid={isEmailValid}
        />
        <Button
          disabled={!isEmailValid || isEmailCheckLoading}
          onClick={onSubmit}
          isLoading={isEmailCheckLoading}
        >
          {t('createInvestorAccount.submit')}
        </Button>
        {submitError.length > 0 && <div className={styles.error}>{submitError}</div>}
      </Form>
      <div className={styles.additionalText}>
        {t('createInvestorAccount.accountNone')}
        <Link to={createAccountLink}>
          {t('createInvestorAccount.accountNoneRegister')}
        </Link>
      </div>
      {isEmailNotFoundError && (
        <div className={styles.error}>
          {t('createInvestorAccount.emailNotFound1')}<br />
          {t('createInvestorAccount.emailNotFound2')}
          <Link to={createAccountLink}>
            {t('createInvestorAccount.emailNotFoundRegister')}
          </Link>
        </div>
      )}
      {isOtherEntityError && (
        <div className={styles.error}>
          {t('createInvestorAccount.otherEntityError')}
        </div>
      )}
    </>
  )
}

export { InvestorAccountForm }
